// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-2Kz0cF6i","title":"title-1muPP-Gn","play_btn":"play_btn-1Ce1uWjZ"};